import { ChangePlanPreview } from '@/api'
import { formatDate, shortMonthInformal } from '@/utils/formatDate/formatDate'

import { ChangePlanOrderSchedule } from '../types'

export type ChangePlanUIInfo = ReturnType<typeof formatPlanPaymentAttributes>

export default function formatPlanPaymentAttributes(
  planChangePreview: ChangePlanPreview | undefined,
  ecomOrderSchedule?: ChangePlanOrderSchedule,
) {
  const newPlan = planChangePreview?.newPlan
  const planAttributes = planChangePreview?.newPlan?.attributes

  return {
    name: planAttributes?.planDescription ?? '-',
    price: planAttributes?.planPriceText ?? '-',
    speed: planAttributes?.planTitle ?? '-',
    changeType: (planChangePreview?.changeType === 'UPGRADE' ? 'upgrade' : 'downgrade') as 'upgrade' | 'downgrade',
    changeTypePastTense: (planChangePreview?.changeType === 'UPGRADE' ? 'upgraded' : 'downgraded') as
      | 'upgraded'
      | 'downgraded',
    totalMonthly: planChangePreview?.ongoingPriceNewPlan ?? '-',
    totalToday: newPlan?.priceInPenceIncludingTax !== undefined ? `£${newPlan.priceInPenceIncludingTax / 100}` : '-',
    canChangeFromDate: formatDate(ecomOrderSchedule?.nextOccurrence, {
      defaultValue: 'next month',
      options: shortMonthInformal,
    }),
    startDate: formatDate(ecomOrderSchedule?.nextOccurrence, {
      defaultValue: 'next month',
      options: shortMonthInformal,
    }),
    startDateWithPreposition: ecomOrderSchedule?.nextOccurrence
      ? `on ${formatDate(ecomOrderSchedule.nextOccurrence, { options: shortMonthInformal })}`
      : 'next month',
    paymentRequired: planChangePreview?.paymentRequired ?? true,
  }
}
